import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux'
import { withRouter } from "react-router";

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import NativeSelect from '@material-ui/core/NativeSelect'
import TablePagination from '@material-ui/core/TablePagination';

import WineFilter from './WineFilter'
import WineInfo from './WineInfo'
import Loading from './Loading'
import EmptyStorage from './common/EmptyStorage'
import TablePaginationActions from 'components/common/TablePaginationActions'

import { getWineList, getCellarStats } from '../actions/asyncWines'
import { formatNumber, deleteEmptyValue, PAGE_SIZE } from 'libraries/utils'

import qtyIcon from 'static/images/icons/qty.svg'
import valueIcon from 'static/images/icons/value.svg'
import costIcon from 'static/images/icons/cost.svg'
import profitlossIcon from 'static/images/icons/profitloss.svg'

class WineList extends React.Component {
    constructor() {
        super()
        this.state = {
            keyword: '',
            filter: {
                country: '', // 國家
                minVintage: '', // 年份 最小
                maxVintage: '', // 年份 最大
                isIncludeNV: '',
                color: '', // red / white / rose / others
                style: '', // still / sparkling / fortified / dessert
                minValue: '', // 市場估值 最小
                maxValue: '', // 市場估值 最大
                volume: '', // 容量
                orderBy: 'update',
                order: 'DESC'
            },
            page: 0,
        }
    }

    componentDidMount() {
        if (this.props.cellarId.length > 0) {
            this.props.getCellarStats(this.props.cellarId)
            this.getWineList()
        }
    }

    getWineList = () => {
        const { filter, page } = this.state
        this.props.getWineList(deleteEmptyValue(filter), page + 1, PAGE_SIZE) // filter, page, perPage
    }

    onEmptyPageClick = () => {
        this.props.history.push('/member/inbound')
    }

    onChange = (changedQuery) => {
        this.setState(state => ({
            filter: {
                ...state.filter,
                ...changedQuery,
            },
            page: 0,
        }), () => {
            window.scrollTo(0, 0)
            this.getWineList()
        })
    }

    onOrderByChange = (event) => {
        const value = event.currentTarget.value
        const orderBy = value.split('_')[0]
        const order = value.split('_')[1]
        this.onChange({
            orderBy,
            order,
        })
    }

    onPageChange = (newPage) => {
        if(newPage !== this.state.page){
            this.setState({ page: newPage }, () => {
                this.getWineList()
            })
        }
    }

    render() {
        const { t, isLoading, list, cellarId, wineListTotalPage } = this.props
        const { filter, page } = this.state
        const summary = this.props.summary || {
            "totalWines": 0,
            "totalValues": 0.0,
            "totalCosts": 0.0,
            "profitAndLoss": 0.0,
            "maxValue": 0.0,
            "minValue": 0.0,
            "vintages": [
                "1972",
                "1978",
                "1996",
                "2005",
                "2006",
                "2009",
                "2010",
                "2012",
                "2013",
                "NV"
            ]
        }

        if (cellarId.length === 0 || !list) {
            return (<EmptyStorage type="wine-list" onClick={this.onEmptyPageClick} />)
        }

        return (
            <Grid container alignItems="center" className="wine-list">
                <Loading isLoading={isLoading} />
                <Typography component="h1" variant="h1">{t('storage_winelist')}</Typography>
                <Grid container justify="space-between" className="dashboard">
                    <Grid item md={9} container justify="flex-start" alignItems="center">
                        <div className="display-flex align-items-center item">
                            <img src={qtyIcon} alt="icon" />
                            <Typography variant="body2">{t('total_wine')}</Typography>
                            <Typography variant="h6">
                                {summary.totalWines}
                            </Typography>
                            <Typography variant="body2">{t('bottle')}</Typography>
                        </div>
                        <div className="display-flex align-items-center item">
                            <img src={valueIcon} alt="icon" />
                            <Typography variant="body2">{t('values')}</Typography>
                            <Typography variant="h6">
                                {formatNumber(summary.totalValues)}
                            </Typography>
                            <Typography variant="body2">{t('TWD')}</Typography>
                        </div>
                        <div className="display-flex align-items-center item">
                            <img src={costIcon} alt="icon" />
                            <Typography variant="body2">{t('total_cost')}</Typography>
                            <Typography variant="h6">
                                {formatNumber(summary.totalCosts)}
                            </Typography>
                            <Typography variant="body2">{t('TWD')}</Typography>
                        </div>
                        <div className="display-flex align-items-center item">
                            <img src={profitlossIcon} alt="icon" />
                            <Typography variant="body2">{t('profit_and_loss')}</Typography>
                            <Typography variant="h6" style={{
                                color: summary.profitAndLoss < 0 ? '#e74c39' : '#1ec280',
                            }}
                            >
                                {summary.profitAndLoss}%
                            </Typography>
                        </div>
                    </Grid>
                    <Grid item md={3} container alignItems="center">
                        <Grid item md={12} className="display-flex align-items-center justify-content-end">
                            {/* <Typography variant="body2"><a href="http://54.65.71.94/show" target="_blank">酒窖溫濕度即時查看</a></Typography> */}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container style={{ marginTop: '45px' }}>
                    <Grid item md={3} style={{ paddingRight: '30px' }}>
                        <WineFilter
                            onChange={this.onChange}
                            summary={summary}
                        />
                    </Grid>
                    <Grid item md={9} style={{ paddingLeft: '15px' }}>
                        <Grid container justify="flex-end" style={{ marginBottom: '24px' }}>
                            <NativeSelect
                                disableUnderline
                                id="sorting"
                                name="sorting"
                                value={`${filter.orderBy}_${filter.order}`}
                                onChange={this.onOrderByChange}
                            >
                                <option value="update_DESC">{t('sort_recently')}</option>
                                <option value="value_DESC">{t('sort_highest_value')}</option>
                                <option value="value_ASC">{t('sort_lowest_value')}</option>
                                <option value="PAL_DESC">{t('sort_highest_profit')}</option>
                                <option value="PAL_ASC">{t('sort_highest_losses')}</option>
                            </NativeSelect>
                        </Grid>
                        <Grid container>
                            {list.map(item => (
                                <WineInfo data={item} key={item.id} />
                            ))}
                            <Grid container>
                                <TablePagination
                                    className="pagination"
                                    rowsPerPageOptions={[]}
                                    labelDisplayedRows={() => null}
                                    count={wineListTotalPage * 10}
                                    rowsPerPage={10}
                                    page={page}
                                    onChangePage={this.onPageChange}
                                    ActionsComponent={TablePaginationActions}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}

const mapStateToProps = state => ({
    isLoading: state.wines.isLoading,
    summary: state.wines.summary,
    list: state.wines.list,
    wineListTotalPage: state.wines.wineListTotalPage,
    cellarId: state.member.member.storageCellarId,
})

const mapDispatchToProps = {
    getWineList,
    getCellarStats,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(withTranslation()(WineList)))